/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EC2PlacementGroup { 
    /**
     * Placement group ID
     */
    id: string;
    /**
     * Placement group name
     */
    name: string;
}

